module.exports = __webpack_public_path__ + "img/5-icono-cancelados-selected.af79c79c.svg";